import ImmutablePropTypes from 'react-immutable-proptypes'
import connectRouter from 'components/Router/connect'
import React, { Component } from 'react'
import TileHero from 'components/TileHero'
import compose from 'recompose/compose'
import { connect } from 'react-redux'
import Link from 'components/Link'
import PropTypes from 'prop-types'

class TileProduct extends Component {
  renderTitle = () => {
    const { props } = this
    const {
      title,
      url,
      type,
    } = props

    if (title) {
      return (
        <Link
          to={url}
          className={`tile-${type}__title`}
          onClick={this.handleGaEvent}
          directLink
        >
          {title}
        </Link>
      )
    }

    return null
  }

  render () {
    const { props } = this
    const {
      auth,
      id,
      title,
      image,
      url,
      preview,
      feature,
      type,
    } = props

    return (
      <div data-type={type} className={`tile-${type}`}>
        <TileHero
          auth={auth}
          id={id}
          title={title}
          image={image}
          url={url}
          preview={preview}
          feature={feature}
          showMoreInfo={false}
          type={type}
          onClickWatch={this.handleGaEvent}
        />
        {this.renderTitle(props)}
      </div>
    )
  }
}

TileProduct.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  id: PropTypes.number,
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  preview: ImmutablePropTypes.map.isRequired,
  feature: ImmutablePropTypes.map.isRequired,
  type: PropTypes.string.isRequired,
}

export default compose(
  connectRouter(),
  connect(
    (state) => ({
      page: state.page,
    }),
  ),
)(TileProduct)
